import { XeroCreateInvoiceConfig } from 'ihub/common';
import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getXeroCreateInvoiceTaskTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];
	const config = microTaskConfigType as XeroCreateInvoiceConfig;
	return [];
}
